import "packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css!=!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA8VY23KbOhR971doJnNmkpkoA9g4Dn3rnwgkgVpAVAjbaef8-9EFZIFxHHCn58E3Xfbea9_Wxi_ssK3anwH4_QUAzNqmRO8JoCU5fVUL-hNiJkgmGa8TkPGyq2q9k6MmAdG2Ucf-_fJihYRGSMoFJiIBYXMCLS8ZBgckHiFElLKawEMElQoiIKtbhsk3cxraS09f3X0oEGZdm4B9YyzhByJoyY8JKBjGxNiQouxHLnhX4-SKjvMJ2AhWIfH-5NkbzYNGJctryCSplPqM1JIIvfy9ayWj7zDjaqWWCWgblBGYEnkk5OyTMLIGNwhjVud2AYQ7u5oOcKXk1VofOQAbA4Aqg2DLfpGJF-x6ZZxqvh8Jywtl-C4I9JoKJheXnpPkJOe8tb2t7NQaZaVeKHplUWCRf6StJcqpeKIvXpqSV-JmorKdBCVSaeVMMzaY2-d7zozdMjPcvdfxvVwwbKxRnwp0pVYlgfZWaysJhFQA1El-C8zfTLHXpESthFnBSuyVtxMfeGf35sAVhJvIIvTOv5nzXJURk8pFwct2v7isZ1MH3VfY560jw7IY-hwALqe3I1cPrWq3LNP_BNLUIL2iMe1UjGqvlscaH2hAXyn1pGVGWg96yKcBtP3tzuJp8OL4z0AiH0GacWLWiVYfzQVKb1YzNcIrVsMepemES3lvTHv5omwzAnpSm9rxlzp5YUM3w6jmxnmDlCVrWtaaUigUFGg4LwE1PwrU3DS554PFrZ990HO14gQM6o03x4n53W9TQ2m-vb1NGUC1oz4MHoYwtEsjCgv_h8L-4VfBQ7qNNuFFc3yglMY09m6VK1PRCajmnLefoZtz-7tj0rvbS_WqsXWI5zkX5vt5j3u1mfd6yMHk62BGo9A2q4RMmG9DKk_kTyNy2LOji9sUn54XF_eHdt0oGu5XjqJyhHPTp__Ak0Hwj431SVtjEsoNSR-l1Z3V47I3UCZcNLKr_DEezqMVKe7PE59jHkU2ndSKNXPUxPdskqh0zEjBS4XrJvN7Z0fxSSjPutbvXQtGIh23AmFNeMqP7qUJQuQpetwEzyCM1Vu0iZ_VoLMJfN3dfbOmKT9S44vRAIlcTQeSX7Togx1h7L7wS-8zJeHEHGcJxm2fRtvhbo9if_t90dONIA1B0jhSjTwVOj2qtvKsnwaeni6c5Ttj0n3CbTClol3_5DP9L-KXG_Rcrs_2eP3cpV-BncBG9Bqne0z0fPwfrw17gCURAAA\"}!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var bar = 'iv4msqz';
export var capabilityIcon = 'iv4msqa';
export var capabilityIconActive = 'iv4msqb';
export var capabilityIconSvg = 'iv4msqc';
export var capabilityRow = 'iv4msq8';
export var capabilityRowInactive = 'iv4msq9';
export var chart = 'iv4msqy';
export var dangerTag = 'iv4msqk';
export var description = 'iv4msq4';
export var dragHandle = 'iv4msqe';
export var empty = 'iv4msq5';
export var endpointField = 'iv4msqq iv4msqp';
export var error = 'iv4msqw';
export var field = 'iv4msqp';
export var fieldHint = 'iv4msqs';
export var form = 'iv4msqo';
export var input = 'iv4msqt';
export var label = 'iv4msqr';
export var locked = 'iv4msqn';
export var modalActions = 'iv4msqu';
export var notice = 'iv4msqm';
export var panel = 'iv4msq1';
export var panelHeader = 'iv4msq2';
export var row = 'iv4msq7';
export var rowActions = 'iv4msql';
export var rowDescription = 'iv4msqh';
export var rowDisabled = 'iv4msqd';
export var rowMain = 'iv4msqf';
export var rowTitle = 'iv4msqg';
export var rows = 'iv4msq6';
export var stack = 'iv4msq0';
export var success = 'iv4msqx';
export var tag = 'iv4msqj';
export var tags = 'iv4msqi';
export var testStatus = 'iv4msqv';
export var title = 'iv4msq3';